import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FirestoreService } from '@app-services/deployments/firestore.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ActiveDeploymentGuard implements CanActivate {
  constructor(
    private firestoreService: FirestoreService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.firestoreService.getActiveDeployment().pipe(
      map((deployment) => {
        if (deployment) {
          this.router.navigate(['/active-deployment']);
          return false;
        }
        return true;
      })
    );
  }
}
